
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSignStairsLeft as ObiSignStairsLeftElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-sign-stairs-left.js';
 
 
 

 
 export const ObiSignStairsLeft = createComponent({
   react: React,
   tagName: 'obi-sign-stairs-left',
   elementClass: ObiSignStairsLeftElement,
   events: {
     
   }
  });
 
 